<template lang="pug">
.agree_view
  .agree_overflow
    .arrow_icon(@click="$router.go(-1)")
      img(src="@/assets/images/arrow_left.svg", alt="alt")
    h1 
      span 零碳智慧租賃服務
      br
      span 同意條款
    .agree_box
      h2 零碳智慧租賃系統服務條款
      p @didifun零碳智慧租賃服務（以下簡稱本公司）係依據本服務條款提供本平台各項服務。當您註冊完成或開始使用本服務時，即表示您已閱讀、了解並同意接受本服務條款之所有內容。如果您不同意本服務條款的內容，或者您所屬的國家或地域排除本服務條款內容之全部或部分時，您應立即停止使用本服務。此外，當您使用本服務之特定功能時，可能會依據該特定功能之性質，而須遵守本服務所另行公告之服務條款或相關規定。此另行公告之服務條款或相關規定亦均併入屬於本服務條款之一部分。本公司有權於任何時間修改或變更本服務條款之內容，並公告於本服務網站上，請您隨時注意該等修改或變更。若您於任何修改或變更後繼續使用本服務，則視為您已閱讀、了解並同意接受該等修改或變更。
      p 若您為未滿十八歲之未成年人，則應請您的父母或監護人閱讀、了解並同意本服務條款之所有內容及其後之修改變更，方得使用本服務。當您使用本服務時，即推定您的父母或監護人已閱讀、了解並同意接受本服務條款之所有內容及其後之修改變更。
      p 本平台服務為免費預約租賃服務及旅遊資訊推薦服務，實際租賃服務規範以店家服務規則為主，您同意並願意遵守以下條款：
      p 
      p 一、隱私權保護政策
      p 本公司相當重視隱私權的保護。關於您的會員註冊以及其他特定資料，將依本服務「隱私權保護政策」保護與規範。您了解並同意當您使用本服務時，本服務可依據「隱私權保護政策」之規範進行您個人資料的蒐集與利用，如LINE@官方帳號、零碳智慧租賃系統等。
      p 
      p 二、一般條款
      p 本服務條款構成您與本公司就您使用本服務之完整合意，取代您先前與本公司間有關本服務所為之任何約定。本服務條款之解釋與適用，以及與本服務條款有關的爭議，除法律另有規定者外，均應依照中華民國法律予以處理，並以台灣台北地方法院為管轄法院。 
      p 本公司未行使或執行本服務條款任何權利或規定，不構成前開權利或規定之棄權。若任何本服務條款規定，經有管轄權之法院認定無效，當事人仍同意法院應努力使當事人於前開規定所表達之真意生效，且本服務條款之其他規定仍應完全有效。
      p 
      p 三、會員的註冊義務及會員帳號、密碼安全
      p 為了能使用本服務，您同意並承諾以下事項：
      p 依本服務註冊流程之提示提供您本人正確及完整的資料，並維持、更新該資料，確保其為正確、最新及完整。
      p 若您提供任何不完整、錯誤或不實的資料，本公司有權暫停或終止您的帳號，並拒絕您使用本服務之全部或部分。
      p 完成本服務的註冊流程後，您將收到註冊通知。您同意並承諾以下事項：
      p 此帳號係不可轉讓。
      p 您有責任維持此帳號及密碼的機密安全。
      p 當您的帳號遭到盜用或有其他任何安全問題發生時，您將立即通知本公司。
      p 
      p 四、會員使用規範與義務
      p 除了遵守本服務條款之約定外，您同意遵守中華民國相關法規、本服務其他服務條款，並同意不從事以下行為： 
      p 您若係中華民國以外之使用者，並同意遵守所屬國家或地域之相關法規。您同意並保證絕不利用本服務從事違法或損害他人權益之行為。
      p 冒用他人名義使用本服務。
      p 侵害他人名譽、隱私權、著作權、智慧財產權及其他權利。
      p 上載、張貼或公布任何不實、誹謗、侮辱、具威脅性、攻擊性、違背公序良俗、引人犯罪或其他不法之文字、圖片或任何形式的檔案。
      p 違反依法律或契約所應負之保密義務。
      p 上載、張貼或公佈任何含有電腦木馬、病毒或任何對電腦軟、硬體產生中斷、破壞或限制功能之程式碼或資料。
      p 從事販賣槍枝、毒品、禁藥、盜版軟體、其他違禁物或其他不法交易行為。
      p 破壞及干擾本服務所提供之各項資料、活動或功能，或以任何方式侵入、試圖侵入、破壞本服務之任何系統，或藉由本服務為任何侵害或破壞行為。
      p 未經同意收集他人電子郵件位址及其他個人資料者。
      p 其他本公司有正當理由認為不適當之行為。
      p 若您有違反前開事項之情事或之虞，本公司有權於通知或未通知之情形下，隨時終止或限制您使用帳號（或其任何部分）或本服務之使用，並將本服務內任何相關「會員內容」加以移除並刪除。您同意若本服務之使用被終止或限制時，本公司對您或任何第三人均不承擔責任。
      p 
      p 五、與第三方網站之連結及第三方提供之內容
      p 本服務可能會提供連結至其他公司/業者(以下稱「第三方」)之網站。第三方之網站均由各公司/業者自行負責，不屬本服務控制及負責範圍之內。本公司對任何檢索結果或外部連結，不擔保其有效性、正確性、合適性、及完整性。您也許會檢索或連結到一些不合適或不需要的網站，遇此情形時，本服務建議您不要瀏覽或儘速離開該等網站。您並同意本公司無須為您連結至前述非屬於本服務之網站所生之任何損害，負損害賠償之責任。 本服務隨時會與其他公司/業者等第三方（以下稱「內容提供者」）合作，由其提供包括遊程、訊息、活動等不同內容供本服務刊登，且本服務於刊登時均將註明內容來源。基於尊重內容提供者之智慧財產權，本服務對其所提供之內容並不做實質之審查或修改。對該等內容之正確真偽，您宜自行判斷之，本公司對該等內容之正確真偽不負任何責任。您若認為某些內容屬不適宜、侵權或有所不實，請逕向該內容提供者反應意見。
      p 
      p 六、服務變更與通知
      p 您同意本公司保留於任何時間點，不經通知隨時修改、暫時或永久停止繼續提供本服務（或其任一部分）的權利。如依法或其他相關規定須為通知時，本服務得以包括但不限於：張貼於本服務網頁、電子郵件，或其他現在或未來合理之方式通知您，包括本服務條款之變更。但若您違反本服務條款，以未經授權的方式存取本服務，或於註冊時所提供之資料不正確或未更新，您將不會收到前述通知。當您經由授權的方式存取本服務，您即同意本服務所為之任何及所有給您的通知，均視為送達。
      p 
      p 七、智慧財產權的保護
      p 本服務所使用之程式、軟體及網站內容，包括但不限於：資訊、資料、圖片、檔案、網站架構、網頁設計、租賃系統及會員內容等，均由本公司或其他權利人依法擁有其智慧財產權，包括但不限於專利權、著作權與專有技術等。任何人不得逕自修改、重製、散布、發行、公開發表、進行還原工程或反向組譯。若您欲引用或轉載前述資料，除明確為法律所允許者外，均須依法事前取得本公司或其他權利人之書面同意。如有違反，您應負損害賠償責任。
      p 
      p ( 更新日期：2024 年 1 月 24 日 )
      hr
      h2 零碳智慧租賃系統隱私權保護政策
      p 本服務是由@didifun零碳智慧租賃服務（以下稱為本公司）所管理。我們非常尊重個人資料的保密性，並承諾遵守應據以適用的隱私權保護法令，因此我們制定本《隱私權保護政策》(以下稱為「本政策」)，用以說明我們如何在您使用本站的服務過程中蒐集、處理、使用及揭露有關您個人資料的政策及程序，並告知您在法律上所受到的隱私權保障。
      p 
      p 當您開始使用本站的服務，即表示您同意我們根據本政策使用您的個人資料，若本政策有未定義的名詞，敬請參照本站的使用條款。一旦使用本站的服務，即表示您同意本政策。
      p 
      p 一、我們蒐集的個人資料
      p 當您使用本站服務時，我們可能會蒐集、處理及使用下列與您有關的個人資料
      p 當您預訂或者註冊成為本站會員或使用我們的服務時，我們會請您提供個人資料，包括但不限於您的姓名、電話、電子郵件等資料；如您是一間公司，我們可能會請您提供的資料，包括但不限於您公司的名稱、公司所在地、電話、電子郵件，以及必備的主要聯絡人相關資料。
      p 在您使用本站服務過程中，我們可能向您請求提交其他為了使用本站服務所必備的其他資料或文件。
      p 如果您不提供本政策第1.A條相關資料，可能無法註冊成為本站會員、無法享受本站的服務，或無法得到我們最完整的服務。
      p 
      p 二、我們蒐集資料的目的
      p 　　我們蒐集您的資料目的如下：
      p 為提供您較佳的本站內容及體驗，並有效管理、辨識本站會員帳戶。
      p 經營並改善本站的服務及行銷方式。
      p 針對您使用本站服務的行為進行研究分析，瞭解本站平台使用者，以改善我們的服務。
      p 確保本站平台能正常營運及具備安全性，包括監控並調查可疑、詐欺或非法的活動，以及辨認違反本站使用條款的行為。
      p 回應您的意見與問題，提供客服服務。
      p 
      p 三、我們的安全措施
      p 為確保您個人資料的安全，我們已採取相關合理且合適的安全措施，保護您的個人資料不遺失、不遭竊及不遭受未授權的存取、使用和修改。但網際網路不可能保證百分之百安全，因此我們無法就您提供的任何資料聲明或保證其絕對安全，除非我們故意揭露您的個人資料，否則一概不承擔任何法律責任。
      p 您同意我們得就您個人資料的隱私安全與您使用本公司服務的管理問題以電子方式聯絡您。如我們發現安全系統存有漏洞，我們可能會藉由在本官方網站上發布通知，或者以發送電子郵件的方式通知您。
      p 
      p 四、Cookies及其他追蹤技術的使用
      p 當您造訪本站平台時，我們可能使用Cookies及其他追蹤技術，包括但不限於網路信標等，自動蒐集有關您使用我們的服務過程中從事活動的資訊。我們可能自動記錄的資訊，包括但不限於您造訪時所在的IP位置、於本站平台停留時間、瀏覽器類型、語言、使用者偏好或點閱紀錄等。
      p 如您不願接受Cookies的使用，您可在您使用的瀏覽器功能選項中設定停用，但可能會導至本站某些功能無法正常執行。
      p 
      p 五、您的資訊與權利
      p 就我們所蒐集的您的個人資料，您可以隨時向我們申請查詢、閱覽或製給複製本，但我們有權視情況向你收取必要的費用。
      p 當您的個人資料有變更或發現個人資料不正確時，您可以在本站會員帳戶補充或更正。當個人資料蒐集的特定目的消失或期限屆滿時，你可以向我們申請停止蒐集、處理、利用或刪除您的個人資料。
      p 我們尊重您申請停止蒐集、處理、利用或刪除個人資料的權益，但在某些情況下，例如為了提供您本站的服務所需，我們可能無法接受您所提出的申請，而必須終止本站的服務。
      p 當您提出上述任一申請時，請透過以下本政策第12條的電郵地址聯絡我們。我們會在收到您申請後，將儘速為您處理。
      p 
      p 六、資訊揭露
      p 如未經過您的事前同意，我們不會將您的個人資料出售或出租給任何第三方。
      p 如未經過您的事前同意，我們不會將您的個人資料揭露給任何第三方；但為了提供您本站的服務，在本政策第2條蒐集資料的目的範圍內，我們會將您的個人資料揭露給第三方我們的合作企業。本條所稱「合作企業」，是指直接或間接透過一個或多個中間機構，控制我們、受我們控制或與我們受到共同控制的任何其他個人或實體。前述所稱「控制」，是指
      p 直接或間接持有實體至少百分之五十的有表決權股份所有權、
      p 擁有直接或間接針對實體的董事會或類似權力單位進行指示或引導之權力，或
      p 直接或間接擁有資金、經營或管理、供應或其他利益，或直接或間接在資金、經營管理、供應或其他利益方面具有密切關係。
      p 我們的財務、會計、法律、保險方面的專業顧問。
      p 
      p 我們如有保護我們法律上權利的需求或按照法律規定而有必要時，我們亦會揭露您的個人資料給行政機關、司法機關或其他司法程序的參與者。
      p 
      p 七、其他第三方網站或服務本站可能包含其他第三方網站或服務的連結，但這不代表我們認可、授權或表示與該第三方網站或服務是關係企業，亦不代表我們為第三方網站或服務的隱私權保護政策背書，我們對第三方網站或服務並沒有控制權。對於此等不屬於本站的第三方網站或服務，不論關於其內容或隱私權保護政策，均與我們無關。
      p 
      p 八、兒童隱私未滿18歲的兒童非本站目標族群，我們不會刻意蒐集兒童的個人資料。在某些司法管轄地區，法定成年人的年齡可能是18歲以上，在這種情況下，您必須達到該年齡的要求方可使用本站服務或者成為本站會員。雖然未滿18歲的個人也可能使用本服務，但他們只能在父母或法定監護人陪同、監督和同意的情況下才能使用。
      p 
      p ​九、國際傳輸如果您使用我們的服務，代表您將傳遞您的個人資料至台灣。如您使用我們的服務或提供資料給我們，即代表您同意任何與隱私或我們的隱私權政策有關的爭議，以台灣法律為準據法，且將依我們的隱私權政策的條款決定。如果您是從歐盟或其他適用資料處理法的地區使用我們的服務，請注意您已同意將傳遞資訊至台灣，且可以運用在全世界。如果您提供您的資料給我們，即代表您同意依我們的隱私權政策傳遞資訊。
      p 
      p ​十、本政策的修訂我們將因需求隨時進行修訂本政策，修訂後的隱私權保護政策將公告在本站上，請隨時查詢最新公告內容
      p 
      p 十一、準據法本政策應以中華民國台灣法律為準據法。如發生爭訟，應以臺灣臺北地方法院為第一審專屬管轄法院。
      p 
      p 十二、聯絡我們若您對本政策有任何疑問，請通過電子郵件與我們聯繫。我們的電子郵件是admin@smartfinder.com.tw。
      p ( 更新日期：2024 年 1 月 24 日 )
      hr
      h2 零碳智慧租賃 個資蒐集聲明
      p 歡迎報名參加由零碳智慧租賃(@didifun So Fun以下稱：@didifun )所主辦、承辦、協辦各項平台活動。當您進行報名活動時，即表示您願意以電子文件之方式行使法律所賦予同意之權利，並具有書面同意之效果。
      p 
      p @didifun為確保與會者之個人資料、隱私及與會者權益之保護，於報名過程中將使用與會者之個人資料，謹依個人資料保護法第8條規定告知以下事項：
      p 
      p 一、蒐集目的及方式本公司之蒐集目的在於進行活動報名作業管理、行銷及內部的統計調查與分析（法定特定目的項目編號為090、040、157）。蒐集方式將透過數位化、電話、紙本或傳真報名等各種方式進行個人資料之蒐集。
      p 
      p --------------------------------------------------
      p 
      p 二、蒐集之個人資料類別本公司於活動報名時蒐集的個人資料包括
      p 
      p C001辨識個人者：如與會者之姓名、地址、電話、電子郵件等資訊。
      p 
      p C002辨識財務者：如信用卡或轉帳帳戶資訊，此資訊蒐集僅限於收費型活動。
      p 
      p --------------------------------------------------
      p 三、利用期間、地區、對象及方式
      p 
      p 期間：本公司營運期間。
      p 
      p 地區：與會者之個人資料將用於台灣地區。
      p 
      p 利用對象及方式：與會者之個人資料蒐集除用於本公司之研討會活動管理、合作單位（含主辦單位、共同主辦、共同協辦、合作夥伴、參展夥伴）管理之檢索查詢等功能外，將有以下利用：
      p 
      p 與會者結構分析：依蒐集之個人資料進行統計分析。
      p 
      p 行銷：與會者名單依蒐集之個人資料進行行銷使用，在與會者同意之下，本公司與合作單位（含主辦單位、共同主辦、共同協辦、合作夥伴、參展夥伴）將進行行銷、聯繫與訊息傳遞。
      p 
      p --------------------------------------------------
      p 
      p 四、與會者個人資料之權利與會者交付本公司個人資料後，於報名時提供之個人資料，得向本公司請求查閱、閱覽、製給複本、補充、更正、停止蒐集/處理/利用、或刪除。 與會者可email洽詢（techserve@smartfinder.com.tw本公司活動客服email進行申請。
      p 
      p ( 更新日期：2024 年 1 月 24 日 )
    .agree_check(:class="{ on_check: agree }", @click="agree = !agree")
      img(v-if="agree", src="@/assets/images/checkbox-v.svg", alt="alt")
    p
      span 我同意上述
    p 租借同意條款
      span 和
      | 隱私權條款
    button.start_btn(
      :class="{ on_check: agree }",
      @click="agreeRules"
    ) 開始租借
</template>

<script>
export default {
  name: "sms-program",
  components: {},
  data () {
    return {
      msg: "你的姓名",
      agree: false,
    };
  },
  methods: {
    agreeRules () {
      if (!this.agree) {
        return
      }

      this.$root.goPage('/member-center')
    }
  },
};
</script>
<style lang="sass" scoped>
.agree_view
  height: 100%
  overflow: auto
  .agree_overflow
    display: flex
    flex-direction: column
    justify-content: center
    padding-top: 18vmin
    position: relative
    .arrow_icon
      position: absolute
      top: 6vmin
      left: 6.1vmin

    h1
      color: #FFF
      font-weight: 500
      font-size: 9vmin
      text-align: center
      margin-bottom: 5vmin
    p
      color: #22F48F
      text-align: center
      font-size: 5vmin
      font-weight: 400
      line-height: 6.2vmin

      span
        color: #fff
        padding: 0 5px
    .agree_box
      border-radius: 5vmin
      border: 1px solid #22F48F
      background: #1E1E1E
      width: 92vmin
      min-height: 103vmin
      margin: 3.5vmin auto 5vmin
      h2
        margin-top: 15px
        color: #22F48F
        font-size: 20px
        text-align: center
      p
        padding:  5px 15px
        font-size: 12px
        color: #FFF
        text-align: left
    .agree_check
      width: 8.5vmin
      height: 8.5vmin
      min-height: 8.5vmin
      background: #D9D9D9
      margin: 0 auto
      display: flex
      align-items: center
      margin-bottom: 2.8vmin
      &.on_check
        background: #22F48F
    .start_btn
      width: 53.5vmin
      background: #898A8D
      border-radius: 25vmin
      color: #1E1E1E
      text-align: center
      font-size: 6vmin
      font-weight: 700
      margin: 6.5vmin auto
      &.on_check
        background: #22F48F

.agree_box
  hr
    width: 100%
    height: 2px
    background-color: #22F48F
  .text-center
    text-align: center !important
</style>